module.exports = __webpack_public_path__ + "img/sixpackcarrier79.b5442abc.jpg";